export default __webpack_public_path__ + "static/media/prototype.428ff0bd.jpeg";